var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info",class:_vm.theme},[_c('p',{staticClass:"name"},[_vm._v(_vm._s(_vm.name))]),_c('p',{staticClass:"sass"},[_vm._v(_vm._s(_vm.sass))]),_c('p',{staticClass:"color"},[_vm._v(_vm._s(_vm.color))])])}
var staticRenderFns = []

export { render, staticRenderFns }